<template>
  <div>
    <Card back>
      <template v-slot:header>
        <!-- Show -->
        <div v-if="showRow">
          <!-- checkin -->
          <h4 class="d-inline">لیست قیمت &nbsp;&nbsp;&nbsp; <a target="_blank" :href="$cookies.get('URL') + 'PriceList\\PriceList.pdf'"> [دانلود فایل لیست قیمت] </a></h4>

          <a class="d-inline float-left mx-2 mt-1" href="javascript:;" @click="changeState(1)" data-title="ردیف جدید">
            <h4>
              <i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i>
            </h4>
          </a>
        </div>

        <!-- Add -->
        <div v-if="addRow">
          <h4 class="d-inline">افزودن</h4>
          <a class="d-inline float-left mx-2 mt-1" href="javascript:;" @click="changeState(0)" data-title="ردیف جدید">
            <h4>
              <i class="fas fa-times text-danger"></i>
            </h4>
          </a>
        </div>

        <!-- Edit -->
        <div v-if="editRow">
          <h4 class="d-inline">ویرایش</h4>
          <a class="d-inline float-left mx-2 mt-1" href="javascript:;" @click="changeState(0)" data-title="ردیف جدید">
            <h4>
              <i class="fas fa-times text-danger"></i>
            </h4>
          </a>
        </div>
      </template>

      <template v-slot:content>
        <!-- Show -->
        <div v-if="showRow">
          <BnpGrid Selectable :action="true" :propsRows="propsRows" :propsColumn="propsColumn" :NoRowNum="true" v-if="render">
            <template slot="price" slot-scope="props">
              {{ props.props.price == 'null' ? '-' : props.props.price }}
            </template>

            <template slot="minPrice" slot-scope="props">
              {{ props.props.minPrice == 'null' ? '-' : props.props.minPrice }}
            </template>

            <template slot="maxPrice" slot-scope="props">
              {{ props.props.maxPrice == 'null' ? '-' : props.props.maxPrice }}
            </template>

            <template slot="action-slot" slot-scope="props">
              <div class="row justify-content-center">
                <div>
                  <a href="javascript:;" class="badge text-center">
                    <h6><span class="fa fa-pencil-square-o hover-info hover-info" @click="edit(props.props)"></span></h6>
                  </a>
                </div>

                <div>
                  <a href="javascript:;" class="badge text-center" @click="remove(props.props)">
                    <h6><span class="fa fa-times hover-danger"></span></h6>
                  </a>
                </div>
              </div>
            </template>
          </BnpGrid>
        </div>

        <!-- Add -->
        <div v-if="addRow" class="mt-3">
          <AddRow @addRowResult="addRowResult"> </AddRow>
        </div>

        <!-- Edit -->
        <div v-if="editRow">
          <EditRow @editRowResult="editRowResult" :item="itemForEdit"> </EditRow>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import AddRow from './PriceListAdd.vue'
import EditRow from './PriceListEdit.vue'

export default {
  components: { Card, BnpGrid, SearchableCombo, AddRow, EditRow },

  data() {
    return {
      propsRows: [],
      propsColumn: [
        { name: 'name', label: 'نام', visibility: true },
        { name: 'productName', label: 'محصول', visibility: true },
        { name: 'price', label: 'قیمت', visibility: true },
        { name: 'func', label: 'فرمول', visibility: true },
        { name: 'minPrice', label: 'حداقل قیمت', visibility: true },
        { name: 'maxPrice', label: 'حداکثر قیمت', visibility: true },
        { name: 'main', label: 'اصلی', visibility: true },
        { name: 'fixPrice', label: 'قیمت ثابت', visibility: true },
        { name: 'isArchive', label: 'بایگانی شده', visibility: true },
        { name: 'expireTime', label: 'تاریخ اتمام', visibility: true },
      ],
      showRow: true,
      addRow: false,
      editRow: false,
      render: false,
      itemForEdit: {},
    }
  },

  mounted() {
    this.getPropsRows()
  },

  methods: {
    changeState(state) {
      if (state == 0) {
        this.showRow = true
        this.addRow = false
        this.editRow = false
      }
      if (state == 1) {
        this.showRow = false
        this.addRow = true
        this.editRow = false
      }
      if (state == 2) {
        this.showRow = false
        this.addRow = false
        this.editRow = true
      }
    },
    addRowResult(isSuccess) {
      if (isSuccess) {
        this.changeState(0)
        this.getPropsRows()
      }
    },
    getPropsRows() {
      let DataaxiosDepUser = {
        Action: 'PriceList',
        Method: 'get',
        ArryfildValue: null,
      }

      this.$PostData(DataaxiosDepUser)
        .then((res) => {
          this.propsRows = res
          this.render = false
          this.propsRows.forEach((el) => {
            el.maxPrice = this.$Comma3ragham(el.maxPrice)
            el.minPrice = this.$Comma3ragham(el.minPrice)
            el.price = this.$Comma3ragham(el.price)
          })
          this.$nextTick(() => {
            this.render = true
          })
        })
        .catch((err) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
          console.error(err)
        })
    },

    editRowResult(isSuccess) {
      if (isSuccess) {
        this.changeState(0)
        this.getPropsRows()
      }
    },

    edit(item) {
      this.itemForEdit = item
      this.changeState(2)
    },

    remove(item) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success mx-1',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })
      swalWithBootstrapButtons
        .fire({
          title: 'اطمینان دارید؟',
          text: 'از حذف ' + item.name + '؟',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'بله، حذف شود',
          cancelButtonText: 'لغو',
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            var DataaxiosDepUser = {
              Action: 'PriceList/' + item.id,
              Method: 'Delete',
              ArryfildValue: null,
            }
            this.$PostData(DataaxiosDepUser)
              .then((response) => {
                if (response.isSuccess) {
                  var record = this.propsRows.find((x) => x.id == item.id)
                  var index = this.propsRows.indexOf(record)
                  this.propsRows.splice(index, 1)
                  this.render = false
                  this.$nextTick(() => {
                    this.render = true
                  })
                  this.$toasted.success('حذف با موفقیت صورت گرفت', {
                    action: {
                      text: 'بستن',
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0)
                      },
                    },
                  })
                } else {
                  swalWithBootstrapButtons.fire('', 'حذف به دلیل رابطه با سایر جداول صورت نگرفت', 'info')
                }
              })
              .catch((error) => {
                console.error('CATCH', error)
                swalWithBootstrapButtons.fire('', 'عملیات با خطا مواجه شد', 'error')
              })
          }
        })
    },
  },
}
</script>

<style scoped></style>
